export function validatePageSelection<T>(
  selectedIds: string[],
  pageRows: T[],
  getId: (r: T) => string,
): T[] | null {
  const rows = pageRows.filter((r) => selectedIds.includes(getId(r)));
  return rows.length === selectedIds.length ? rows : null;
}

export const recycleBinTableSx = {
  '& .MuiDataGrid-row': { cursor: 'default' },
  border: 'none',
  overflow: 'hidden',
  width: '100%',
  '& .MuiDataGrid-virtualScroller': {
    overflowY: 'auto',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'rgba(249, 250, 251, 0.8)',
    borderBottom: '1px solid #e5e7eb',
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox)': {
      px: '16px',
      py: '12px',
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    letterSpacing: '0.05em',
    fontWeight: 600,
    color: '#6b7280',
  },
  '& .MuiDataGrid-cell:not(.MuiDataGrid-cellCheckbox)': {
    px: '16px',
    py: '12px',
  },
  '& .MuiDataGrid-cellCheckbox': {
    py: '12px',
    pl: 0.5,
    pr: 1.5,
    justifyContent: 'center',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'rgba(249, 250, 251, 0.8)',
  },
  '& .MuiDataGrid-footerContainer': {
    overflow: 'hidden',
  },
  '& .MuiTablePagination-displayedRows': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    py: '12px',
    pl: 0.5,
    pr: 1.5,
    justifyContent: 'center',
  },
};
